<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { signupStore } from "$app/signupstore.svelte"
  import { appStore } from "$app/store.svelte"

  let showModal = $state(false)
  let plan_name = $state("")
  let saving = $state(false)
  let button: HTMLButtonElement

  export function open(): void {
    showModal = true
  }

  async function requestDeletePlan(): Promise<void> {
    if (appStore.plan.name !== plan_name) {
      return
    }

    if (signupStore.subscription.subscription_type === "free") {
      deletePlan()
    } else {
      try {
        saving = true
        let resp = await xhr.patch(
          `/plans/${appStore.plan.id}/admin/billing/request_plan_deletion`,
          { request_delete: "true" }
        )

        appStore.plan = resp.data

        toast("Your plan has been queued for deletion", "success")
      } catch (e: any) {
        Honeybadger.notify(e)
        toast("There was an error requesting plan deletion", "error")
      } finally {
        saving = false
      }
    }
  }

  async function deletePlan(): Promise<void> {
    if (appStore.plan.name !== plan_name) {
      return
    }

    try {
      saving = true
      await xhr.delete(
        `/plans/${appStore.plan.id}/subscriptions/${signupStore.subscription.id}`
      )
      toast("Your plan has been deleted, you are being redirected", "success")
      setTimeout(() => {
        window.location = "/users/sign_in"
      }, 500)
    } catch (e) {
      Honeybadger.notify(e)
    } finally {
      saving = false
    }
  }

  $effect(() => {
    if (button) {
      if (appStore.plan.name === plan_name) {
        button.removeAttribute("disabled")
      } else {
        button.setAttribute("disabled", "disabled")
      }
    }
  })
</script>

<button
  class="flex items-center justify-center rounded-md border border-gray-300 bg-white py-2 px-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 hover:cursor-pointer"
  onclick={() => {
    plan_name = ""
    showModal = true
  }}
>
  {#if signupStore.subscription.name === "Free"}
    Delete Plan
  {:else}
    Request Deletion
  {/if}
</button>

<Modal bind:open={showModal}>
  <h3 class="text-center text-2xl">
    Are you sure you want to delete the plan?
  </h3>
  <div class="mt-4">
    {#if signupStore.subscription.subscription_type === "free"}
      Deleting your plan will automatically cancel any active subscriptions and
      deletes all your plan data. This is irreversable!
    {:else}
      By requesting your plan to be deleted it will be placed in a queue for
      deletion. You may be contacted by Lead With Purpose support to confirm.
    {/if}
  </div>

  <div class="text-base mt-4">
    Please type <span class="font-semibold">{appStore.plan.name}</span> to confirm.
  </div>
  <div class="py-2 px-4">
    <input type="text" bind:value={plan_name} class="w-full input" />
  </div>

  <div class="text-center">
    <button
      class="btn bg-gray-200 hover:bg-gray-300 cursor-pointer mr-10"
      onclick={() => (showModal = false)}
      tabindex="0"
    >
      No, Don't Delete
    </button>

    <button
      class="btn danger cursor-pointer"
      bind:this={button}
      onclick={requestDeletePlan}
      disabled={!plan_name || appStore.plan.name !== plan_name}
      tabindex="0"
    >
      {#if signupStore.subscription.subscription_type === "free"}
        Yes, Delete Plan
      {:else}
        Request Plan Deletion
      {/if}
    </button>
  </div>
</Modal>
